import ProductPickUpModal from './ProductPickUpModal';

export default ProductPickUpModal;
